import React from "react";
import img_1 from "../../images/icons/location.png";
import img_2 from "../../images/icons/down.png";
import img_3 from "../../images/icons/icon14.png";
import img_4 from "../../images/icons/debit.png";

export interface StatisticHomeSectionProps {
  headingTitle?: string;
  className?: string;
  img1?: string;
  img2?: string;
  img3?: string;
  img4?: string;
  img5?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  title4?: string;
  title5?: string;
  val1?: string;
  val2?: string;
  val3?: string;
  val4?: string;
  val5?: string;
}

const IconsList4: React.FC<StatisticHomeSectionProps> = ({
  className,
  headingTitle = "Ce que comprend la visite ?",
  img1 = img_1,
  img2 = img_2,
  img3 = img_3,
  img4 = img_4,
  title1 = "Trajet du ru de Gally",
  title2 = "Bassin-versant hydrographique",
  title3 = "Communes traversées",
  title4 = "Débit moyen",

  val1 = "22 kilomètres De Versailles à Beynes",
  val2 = "12 000 hectares Chaque goutte d’eau y rejoint le ru de Gally",
  val3 = "17 communes drainées par le cours d’eau",
  val4 = "0,66 m³/s d’écoulement du ru de Gally ",
}) => {
  const stats = [
    { img: img1, title: title1, val: val1 },
    { img: img2, title: title2, val: val2 },
    { img: img3, title: title3, val: val3 },
    { img: img4, title: title4, val: val4 },
  ];

  return (
    <div
      className={`relative   bg-[#1699761A] ${className}`}
      style={{ zIndex: 0 }}
    >
      <div className="mb-10 text-xl font-bold text-center text-black">
        {headingTitle}
      </div>

      {/* Container for the stats items */}
      <div className="flex flex-wrap justify-center mb-10 space-x-16 xl:gap-0 xl:flex-nowrap ">
        {stats.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col items-center text-center max-w-[254px] px-4  `}
          >
            <div
              className="w-20 h-20 mx-auto mb-4 bg-primary"
              style={{
                mask: `url(${item.img}) no-repeat center`,
                maskSize: "contain",
                WebkitMask: `url(${item.img}) no-repeat center`,
                WebkitMaskSize: "contain",
              }}
            />
            <div className="mb-2 text-lg font-bold text-black whitespace-nowrap">
              {item.title}
            </div>
            <div className="text-sm font-bold text-primary">{item.val}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IconsList4;
